import { forwardRef } from 'react';
import type { SVGProps, Ref } from 'react';
type Props = SVGProps<SVGSVGElement>;
/**
 * @public
 */
const SvgStep8 = forwardRef((props: Props, svgRef: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    viewBox="0 0 32 32"
    ref={svgRef}
    {...props}
  >
    <circle cx={16} cy={16} r={15} stroke="#DFE1E6" strokeWidth={2} />
    <path
      fill="currentColor"
      d="M16 21.792a6.89 6.89 0 01-1.823-.224 4.362 4.362 0 01-1.36-.656 3.116 3.116 0 01-.848-1.024 3.1 3.1 0 01-.288-1.344c0-.63.192-1.19.576-1.68.384-.501.955-.853 1.712-1.056a2.978 2.978 0 01-1.408-.944c-.373-.448-.56-.981-.56-1.6 0-.448.085-.859.256-1.232.181-.373.443-.693.784-.96a3.63 3.63 0 011.248-.64A6 6 0 0116 10.208c.64 0 1.205.075 1.696.224.501.15.923.363 1.264.64.352.267.613.587.784.96.181.373.272.784.272 1.232 0 .619-.187 1.147-.56 1.584a3.44 3.44 0 01-1.424.96c1.525.47 2.288 1.381 2.288 2.736 0 .49-.101.939-.304 1.344a2.875 2.875 0 01-.848 1.024c-.363.277-.81.496-1.344.656-.533.15-1.141.224-1.824.224zm0-2.016c.662 0 1.148-.128 1.457-.384.31-.256.464-.603.464-1.04 0-.48-.181-.859-.544-1.136-.352-.288-.81-.475-1.376-.56-.565.085-1.03.272-1.392.56-.352.277-.528.656-.528 1.136 0 .437.16.784.48 1.04.32.256.8.384 1.44.384zm0-4.752c.48-.085.87-.25 1.169-.496.299-.256.448-.608.448-1.056 0-.416-.144-.725-.432-.928-.277-.213-.672-.32-1.184-.32-.501 0-.896.107-1.184.32-.277.203-.416.512-.416.928 0 .448.144.8.432 1.056.299.245.688.41 1.168.496z"
    />
  </svg>
));
SvgStep8.defaultProps = {
  'aria-hidden': true,
  focusable: 'false',
  role: 'img',
};
export default SvgStep8;
